var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFacebookLogo = function SvgFacebookLogo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Social icons",
    clipPath: "url(#clip0_50_224)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    d: "M12 0.95459C18.6274 0.95459 24 6.32717 24 12.9546C24 18.944 19.6118 23.9086 13.875 24.8088V16.4233H16.6711L17.2031 12.9546H13.875V10.7046C13.875 9.75561 14.34 8.82959 15.8306 8.82959H17.3438V5.87646C17.3438 5.87646 17.1846 5.84931 16.9229 5.81349C16.5118 5.75722 15.8477 5.67957 15.1498 5.65216C14.9867 5.64575 14.8216 5.64209 14.6576 5.64209C11.9166 5.64209 10.125 7.30334 10.125 10.3108V12.9546H7.07812V16.4233H10.125V24.8088C4.3882 23.9086 0 18.944 0 12.9546C0 6.32717 5.37258 0.95459 12 0.95459Z",
    fill: "#E3E8EF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50_224"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.95459)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFacebookLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/facebook-logo.5a858703fb7ad06298f1c2280a035ac1.svg";